import React from 'react';
import { Navigate, useLocation } from 'react-router-dom'; // Import useLocation here
import { hasPermission } from '../../utils/permissions';

/**
 * PrivateRoute component to protect routes that require authentication
// Removed duplicate import below

/**
 * PrivateRoute component to protect routes that require authentication
 * and handle onboarding redirection.
 */
const PrivateRoute = ({ children }) => {
  const location = useLocation(); // Get current location

  // Check for authentication token
  const isAuthenticated = () => {
    const token = localStorage.getItem('token');
    return !!token;
  };

  // Check if onboarding is complete from the stored user object
  const isOnboardingComplete = () => {
    try {
      const userString = localStorage.getItem('user');
      if (!userString) return false; // Assume not complete if no user data
      const user = JSON.parse(userString);
      // *** DEBUG LOG ***
      console.log('[PrivateRoute] User data from localStorage:', user);
      const isComplete = user?.company_onboarding_complete === true;
      console.log('[PrivateRoute] Company onboarding complete status check:', isComplete);
      // *** END DEBUG LOG ***
      // Check the COMPANY's onboarding status from the user object
      // Default to false if missing (e.g., older user data in localStorage)
      return isComplete;
    } catch (err) {
      console.error('[PrivateRoute] Error checking company onboarding status from localStorage:', err);
      return false; // Default to false on error
    }
  };

  if (!isAuthenticated()) {
    // Not authenticated, redirect to login
    return <Navigate to="/login" />;
  }

  if (!isOnboardingComplete() && location.pathname !== '/onboarding') {
    // Authenticated but COMPANY onboarding not complete, and not already on onboarding page
    console.log('User authenticated but company onboarding incomplete, redirecting to /onboarding');
    return <Navigate to="/onboarding" />;
  }

  // Authenticated and onboarding is complete (or user is on the onboarding page)
  return children;
};

/**
 * RoleRestrictedRoute component to protect routes that require specific roles
 */
export const RoleRestrictedRoute = ({ children, allowedRoles }) => {
  // Check if user is authenticated
  const isAuthenticated = () => {
    const token = localStorage.getItem('token');
    return !!token;
  };
  
  // Check if user has one of the allowed roles
  const hasAllowedRole = () => {
    try {
      const userString = localStorage.getItem('user');
      if (!userString) return false;
      
      const user = JSON.parse(userString);
      return allowedRoles.includes(user.role);
    } catch (err) {
      console.error('Error checking user role:', err);
      return false;
    }
  };
  
  if (!isAuthenticated()) {
    return <Navigate to="/login" />;
  }
  
  // If user is authenticated but doesn't have an allowed role, redirect to dashboard
  if (!hasAllowedRole()) {
    return <Navigate to="/" />;
  }
  
  return children;
};

/**
 * PermissionRestrictedRoute component to protect routes that require specific permissions
 */
export const PermissionRestrictedRoute = ({ children, category, permission }) => {
  // Check if user is authenticated
  const isAuthenticated = () => {
    const token = localStorage.getItem('token');
    return !!token;
  };

  if (!isAuthenticated()) {
    return <Navigate to="/login" />;
  }
  
  // Check if user has the required permission
  if (!hasPermission(category, permission)) {
    return <Navigate to="/" />;
  }
  
  return children;
};

export default PrivateRoute;
